import { API_PATH, BASE_PATH } from '../../constants';
import axios from 'axios';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import moneyFormat from '../../utils/moneyFormat';
import { setUrlParameter } from '../../utils/url';

let stateSelected = window.state === 'CAMPINAS' ? 'SP' : window.state;
let limitItens = 12;
let pageIndex = 1;
let totalPages = 1;

const selectors = {
  root: 'root',
  loading: 'is-loading',
  valueLower: 'value-lower',
  valueUpper: 'value-upper'
};

const filters = ['regions', 'status', 'bedrooms', 'type', 'price'];

const addLoading = () => {
  document.getElementById(selectors.root).classList.add(selectors.loading);
}

const removeLoading = () => {
  document.getElementById(selectors.root).classList.remove(selectors.loading);
}

const closeFilters = () => {
  filters.map(filter => {
    document.getElementById(`filter-${filter}`).style.display = 'none';
  });
}

const openFilter = filter => {
  closeFilters();
  document.getElementById(`filter-${filter}`).style.display = 'block';
}

const closeFiltersOnOutsideClick = () => {
  window.addEventListener('click', function(e){  
    if(e.target.closest('.group-filter-relative') === null){
      closeFilters();
    }
  });
}

const initBtnSlider = () => {
  const slider = document.querySelector('.btns-filter');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });
}

const getDetails = (details) => {
  let htmlBodyDetails = '';

  details.forEach((objData, index) => {
    if (index > 5) return;

    let item = `
            <div class="box-option">
				<img src="${BASE_PATH + objData.icon}" alt="${objData.label}" />
				<p>${objData.label}</p>
			</div>
        `;

    htmlBodyDetails += item;
  });

  return htmlBodyDetails;
}

const getAllUrlParams = url => {

  let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  const obj = {};

  if (queryString) {
    queryString = queryString.split('#')[0];

    const arr = queryString.split('&');

    for (let i = 0; i < arr.length; i++) {
      const a = arr[i].split('=');

      let paramName = a[0];
      let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

      if (paramName.match(/\[(\d+)?\]$/)) {

        const key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = [];

        if (paramName.match(/\[\d+\]$/)) {
          const index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          obj[key].push(paramValue);
        }
      } else {
        if (!obj[paramName]) {
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

const renderCartItem = ({ link, cover, status, nbhood_subregion, title, details, highlight_text }) => {
  let htmlBody = `
        <div class="col-sm-4">
            <a class="box-product-link-search" href="/${link}">
                <div class="box-product">
                    <img class="img-product" src="${BASE_PATH + cover}" alt="${title}">
                    <div class="about-building">
                        <div class="status ${status.slug}"><p>${status.label}</p></div>
                        <h4>${title}</h4>
                        <span>${nbhood_subregion}</span>
                        <p>${highlight_text}</p>
                        <div class="options-building">
                            ${getDetails(details)}
                        </div>
                    </div>							
                </div>
            </a>
        </div>
    `;

  return htmlBody;
}

const renderPageButton = (index, active) => (`    
    <a class="${active ? 'active' : ''}" href="#">${index}</a>
`);

const renderPagination = (index, totalItens, limitPerPage) => {
  pageIndex = index;
  totalPages = totalItens > 0 ? Math.ceil(totalItens / limitPerPage) : 0;

  const paginateContainer = document.querySelector('.paginate .pages');

  Array.prototype.slice.call(document.querySelectorAll('.paginate a')).map(element => (
    element.removeEventListener('click', clickPageHandler)
  ))

  paginateContainer.innerHTML = '';
  for (let i = 1; i <= totalPages; i++) {
    paginateContainer.insertAdjacentHTML('beforeend', renderPageButton(i, i == index))
  }

  Array.prototype.slice.call(document.querySelectorAll('.paginate a')).map(element => (
    element.addEventListener('click', clickPageHandler)
  ))

  function clickPageHandler(e) {
    e.preventDefault();
    let params = getAllUrlParams();
    if (e.currentTarget.id == 'prev-page' || e.currentTarget.id == 'next-page') {
      if (e.currentTarget.id == 'prev-page') pageIndex--;
      if (e.currentTarget.id == 'next-page') pageIndex++;

      if (pageIndex == 0) pageIndex = 1;
      if (pageIndex > totalPages) pageIndex = totalPages;

    } else {
      pageIndex = e.target.textContent;
    }
    
    httpRequest({...params, page:pageIndex});
  }
}

const renderItems = items => {
  let productsContainer = document.querySelector('.products-container');
  productsContainer.innerHTML = '';
  console.log("renderItems")
  console.log(items)
  let htmlBody = '<div class="row">';
  if (items.length == 0) {
    htmlBody += '<p>Não encontramos nenhum imóvel com essas características. <br>Favor refazer a busca.</p>';
  } else {
    items.map(item => {
      htmlBody += renderCartItem(item);
    });
  }
  htmlBody += '</div>';

  productsContainer.innerHTML = htmlBody;
}

// const filterBox = document.getElementById('filter-type');
// const windowWidth = window.innerWidth;
// const percentUnit = '%';
// const unit = 'px';

// filterBox.style.left = (window.innerWidth + "px") - (70 + "vw");

// console.log(filterBox.style.left);


const getValuesCheckbox = (inputName) => {
  var inputsCheckbox = []
    .slice
    .call(document.querySelectorAll('input[type="checkbox"]'))
    .filter(item => item.name === inputName && item.classList.contains(stateSelected.toLowerCase()))
    .filter(item => item.checked)
    .map(item => Number(item.value))
    .toString();

  // console.log('>>> inputsCheckbox :: '+ className + " -- "+ inputsCheckbox);
  console.log(inputsCheckbox);
  return inputsCheckbox
}

const getRadioChecked = () => {
  stateSelected = document.querySelector('input[name="state"]:checked').value;
  console.log(document.querySelector('input[name="state"]:checked').value);
  return stateSelected;
}

const snapSlider = document.getElementById('range-slider');

const snapValues = [
  document.getElementById(selectors.valueLower),
  document.getElementById(selectors.valueUpper)
];

const currencyOpt = {
  thousand: '.',
  decimals: 0,
  suffix: ' mil'
}

let sliderMin = parseInt(document.getElementById('range-slider').getAttribute('data-range-min') || 100);
let sliderMax = parseInt(document.getElementById('range-slider').getAttribute('data-range-max') || 500);
let sliderDefaultMin = sliderMin;
let sliderDefaultMax = sliderMax;
let urlParams = getAllUrlParams();

if (urlParams.pricerange && urlParams.pricerange.indexOf(',')) {
  sliderDefaultMin = urlParams.pricerange.split(',')[0];
  sliderDefaultMax = urlParams.pricerange.split(',')[1];
}

noUiSlider.create(snapSlider, {
  start: [sliderDefaultMin, sliderDefaultMax],
  connect: true,
  tooltips: [wNumb(currencyOpt), wNumb(currencyOpt)],
  range: {
    'min': sliderMin,
    'max': sliderMax
  }
});

snapSlider.noUiSlider.on('update', function (values, handle, unencoded) {
  snapValues[handle].innerHTML = moneyFormat.to(unencoded[handle]);
});

const changeFilterPriceButton = () => {
  const minValue = snapValues[0].textContent.replace('.', '');
  const maxValue = snapValues[1].textContent.replace('.', '');

  if (100 != minValue || 500 != maxValue) {
    document.querySelector(`#btn-filter-price`).classList.add('btn-filtered');
  } else {
    document.querySelector(`#btn-filter-price`).classList.remove('btn-filtered');
  }
}

const changeFilterButtons = itemName => {
  let countRegions = 0;

  Array.prototype.slice
    .call(document.querySelectorAll(`input[name="${itemName}"]`))
    .map(item => {
      if (item.checked && item.classList.contains(stateSelected.toLowerCase())) {
        countRegions++;
        console.log(item.checked);
      }
    });

  if (countRegions > 0) {
    document.querySelector(`#btn-filter-${itemName}`).classList.add('btn-filtered');
  } else {
    document.querySelector(`#btn-filter-${itemName}`).classList.remove('btn-filtered');
  }

  document.querySelector(`#btn-filter-${itemName} .qtd-filtered`).innerHTML = countRegions.toString();
}

const updateSearchTitle = () => {
  if (document.querySelector(`input[value="RJ"].state`).checked == true) {
    document.querySelector('#tituloEstado').innerHTML = 'Imóveis no Rio de Janeiro'
  } else {
    document.querySelector('#tituloEstado').innerHTML = 'Imóveis em São Paulo'
  }
}

const httpRequest = async (params) => {
  addLoading();
  closeFilters();

  window.scrollTo({ top: 0, behavior: 'smooth' });

  const homologUrl = `${API_PATH}/products`;
  console.log(params);
  if (!params) {
    params = {
      state: stateSelected,
      page: pageIndex,
      regions: getValuesCheckbox('regions'),
      limit: limitItens
    };
  } else {
    if (!params.regions) params.regions = getValuesCheckbox('regions');
    if (!params.state) params.state = (window.state === 'CAMPINAS' ? 'SP' : window.state);
    if (!params.page) params.page = pageIndex;
    if (!params.limit) params.limit = limitItens;
  }

  params.adjust_price = 1;

  const request = await axios.get(homologUrl, { params });
  const response = request.data;

  if (response) {
    updateSearchTitle();
    changeFilterPriceButton();
    changeFilterButtons('regions');
    changeFilterButtons('status');
    changeFilterButtons('bedrooms');
    changeFilterButtons('type');

    renderItems(response.data);
    renderPagination(response.page, response.total, params.limit);

    removeLoading();
  }
}

const filterRequest = () => {
  const minValue = snapValues[0].textContent.replace('.', '');
  const maxValue = snapValues[1].textContent.replace('.', '');

  const objRequest = {
    state: getRadioChecked(),
    regions: getValuesCheckbox('regions'),
    status: getValuesCheckbox('status'),
    type: getValuesCheckbox('type'),
    bedrooms: getValuesCheckbox('bedrooms'),
    pricerange: `${minValue},${maxValue}`,
    limit: limitItens,
    page: 1
  }

  Object.keys(objRequest).map(item => {
    window.history.replaceState('', '', setUrlParameter(window.location.href, item, objRequest[item]));
  });

  httpRequest(objRequest);
}


const toogleStates = (uf) => {
  uf = (uf === 'CAMPINAS') ? 'SP' : uf;

  // filterScrollbar.update();

  console.log('Update to state : ', uf);

  if (uf.toUpperCase() == 'SP') {
    Array.prototype.slice
      .call(document.querySelectorAll('.content-sp'))
      .map((item) => item.style.display = 'block');

    Array.prototype.slice
      .call(document.querySelectorAll('.content-rj'))
      .map((item) => item.style.display = 'none');
  } else {
    Array.prototype.slice
      .call(document.querySelectorAll('.content-sp'))
      .map((item) => item.style.display = 'none');

    Array.prototype.slice
      .call(document.querySelectorAll('.content-rj'))
      .map((item) => item.style.display = 'block');
  }
}

(() => {
  const urlParams = getAllUrlParams();

  initBtnSlider();

  closeFiltersOnOutsideClick();

  Array.prototype.slice
    .call(document.querySelectorAll('.btn-exec-filter'))
    .map(item => {
      item.addEventListener('click', e => {
        filterRequest();
      });
    });

  Array.prototype.slice
    .call(document.querySelectorAll('input[name="state"]'))
    .map(item => {
      item.addEventListener('click', (e) => {
        toogleStates(e.currentTarget.value);
      });
    });

  Array.prototype.slice
    .call(document.querySelectorAll('.box-filter .btn-close'))
    .map(item => {
      item.addEventListener('click', (e) => {
        closeFilters();
      });
    });

  filters.map(filter => {
    document.getElementById(`btn-filter-${filter}`).addEventListener('click', e => openFilter(filter));
  });

  let stateFilterSite = window.state === 'CAMPINAS' ? 'SP' : window.state;

  if (Object.keys(urlParams).length > 0) {
    stateSelected = !urlParams.state ? stateFilterSite : urlParams.state;
  } else {
    stateSelected = stateFilterSite;
  }

  if (Object.keys(urlParams).length > 0) {


    if (!urlParams.state) {
      urlParams.state = window.state === 'CAMPINAS' ? 'sp' : window.state.toLowerCase();
    }

    console.log(Object.keys(urlParams))

    Object.keys(urlParams).map(item => {
      console.log(item);
      return String(urlParams[item]).split(',').map((v, i) => {
        console.log(item, v);
        const element = document.querySelector(`input[value="${v.toUpperCase()}"][name="${item}"].${urlParams.state == 'sp' ? 'sp' : 'rj'}`);
        console.log(element);
        console.log('------')
        // console.log(element);
        if (element) element.checked = true;
      })
    });
  }

  toogleStates(urlParams.state ? urlParams.state : window.state);
  httpRequest(urlParams);
})();
